export function voiceStatusLabel(voice, copy) {
  if (voice.muted) return copy.muted;
  if (voice.speaking) return copy.speaking;
  if (voice.thinking) return copy.thinking;
  return copy[voice.status];
}

export function voiceActivity(voice) {
  if (voice.speaking) return 'speaking';
  if (voice.status === 'connected' && !voice.muted) return 'listening';
  return 'quiet';
}